import React from "react";
import { Helmet } from "react-helmet-async";
import SupportHeader from "./SupportHeader";
import SupportContent from "./SupportContent";
import { useWhitelabel } from "../../../contexts/WhitelabelContext";

export const SupportPage = () => {
  const { faviconUrl } = useWhitelabel();

  return (
    <React.Fragment className="p-0">
      <Helmet title="Support">
        <link rel="icon" href={faviconUrl} />
      </Helmet>
      <SupportHeader />
      <SupportContent />
    </React.Fragment>
  );
};

export default SupportPage;
